export const getCodeScript = (type, project_id, chat_id) => {
    switch (type) {
        case 'div':
            return `<body>
    <div id="centribal_id">
    </div>
</body>
<script id="cen_snippet_static"
        src="${process.env.REACT_APP_URL_CHAT}/snippet_static.js?key=${project_id}.${chat_id}&ref_id=centribal_id&no_animation=true"
        type="text/javascript">
</script>
<style>
    div#centribal_id {
        height: 100%;
        width: 100%;
        overflow: hidden;
        position: fixed;
    }
</style>`
        case 'widget':
            return `<script id="bim-snippet"
    src="${process.env.REACT_APP_URL_CHAT}/app/chat?key=${project_id}.${chat_id}"
    type="text/javascript">
</script>`;
    }
}